// extracted by mini-css-extract-plugin
export default {"cus_input":"LoginModal_cus_input__mgpTz","input_mar":"LoginModal_input_mar__XitK7","lgn_btn_div":"LoginModal_lgn_btn_div__6wcxz","modalMain":"LoginModal_modalMain__OijnD"};